import { MenuItem } from "@mui/material"

export function SimpleMenuItem({ item }) {
    return (
        <MenuItem key={item} value={item}>
            {item}
        </MenuItem>
    )
}
